let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '购买订单编号',
        props: 'mapNo',
        minWidth: 300,
    },
    {
        label: '订单状态',
        props: 'orderStatusName',
        minWidth: 180,
    },
    {
        label: '用户手机号',
        props: 'custMobile',
        minWidth: 200,
    },
    {
        label: '购买类型',
        props: '',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            return '家充无忧服务';
        }
    },
    {
        label: '购买名称',
        props: 'buyName',
        minWidth: 320,
    },
    {
        label: '购买内容',
        props: 'buyContent',
        minWidth: 320,
    },
    {
        label: '实收金额（元）',
        props: 'cancelAmount',
        minWidth: 160,
    },
    {
        label: '设备折旧费净值（元）',
        props: 'depreciationNetPrice',
        minWidth: 200,
    },
    {
        label: '已支付服务费总额（元）',
        props: 'payedServiceAmount',
        minWidth: 200,
    },
    {
        label: '上门拆桩费用（元）',
        props: 'disassemblyPrice',
        minWidth: 160,
    },
    {
        label: '购买金额（元）',
        props: 'walletListReceiptAmount',
        minWidth: 200,
    },
    {
        label: '购买时间',
        props: 'transactionSuccessTime',
        minWidth: 200,
    },
    {
        label: '支付方式',
        props: 'transactionChannelName',
        minWidth: 200,
        formatter: (row, column, cellValue, index) => {
            if (row.transactionPlatform === 'ALIPAY') {
                return "支付宝";
            } else if (row.transactionPlatform === 'ALIPAY_SESAME') {
                return '支付宝(芝麻信用)'
            } else if (row.transactionPlatform === 'WECHAT') {
                return '微信支付'
            }
        }
    },
    {
        label: '交易流水号',
        props: 'transactionId',
        minWidth: 300,
    },
    {
        label: '退款操作时间',
        props: 'refundOperateTime',
        minWidth: 200,
    },
    {
        label: '退款完成时间',
        props: 'refundFinishTime',
        minWidth: 200,
    },
    {
        label: '退款金额（元）',
        props: 'refundAmount',
        minWidth: 200,
    },
    {
        label: '退款原因',
        props: 'refundReason',
        minWidth: 200,
    },
    {
        label: '退款原因备注',
        props: 'refundRemark',
        minWidth: 200,
    },
    {
        label: '退款类型',
        props: 'refundType',
        minWidth: 200,
        formatter: (row, column, cellValue, index) => {
            if (row.refundType === 'ALL') {
                return "全额退款";
            } else if (row.refundType === 'PART') {
                return '部分退款'
            }
        }
    },
    {
        label: '退款方式',
        props: 'refundWay',
        minWidth: 200,
        formatter: (row, column, cellValue, index) => {
            if (row.refundWay === 'FREE') {
                return "芝麻免押";
            } else if (row.refundWay === 'MANUAL') {
                return '手动退款'
            }
        }
    },
    {
        label: '是否恢复服务使用',
        props: 'resetUse',
        minWidth: 200,
        formatter: (row, column, cellValue, index) => {
            if (row.resetUse === 'Y') {
                return "是";
            } else if (row.resetUse === 'N') {
                return '否'
            }
        }
    },
    {
        label: '退款结果',
        props: 'refundResult',
        minWidth: 200,
        formatter: (row, column, cellValue, index) => {
            if (row.refundResult === 'Y') {
                return "成功";
            } else if (row.refundResult === 'N') {
                return '失败'
            }
        }
    },
    {
        label: '退款操作人',
        props: 'refundByName',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '订单管理'
    },
    {
        type: 'title',
        name: '家充无忧服务订单'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-详情操作
// pageConfig.tableDetailObj = {
//     editKey: 'id',
//     editRouter: 'pileDetailTab',
// };

// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileDetail',
};

// 路由
pageConfig.listRouter = 'pileList';

pageConfig.reportDetailRouter = 'pileReportDetail';

pageConfig.chargeDetailRouter = 'pileChargeDetail';

pageConfig.repairListDetail = 'repairListDetail';

pageConfig.faultDetail = 'faultDetail';

//维修新增路由
pageConfig.repairAddRouter = 'repairAddDetail';

//维修路由
pageConfig.repairRouter = 'repairDetail';

// 关联账号
pageConfig.relationNum = 'relationNum';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '充电桩详情'
    }
];

// 关联账号 详情面包屑
pageConfig.relationBreadCrunm = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理',
    },
    {
        type: 'router',
        name: '充电桩管理',
        router: 'pileList'
    },
    {
        type: 'title',
        name: '关联账号详情'
    }
]

pageConfig.formRules = {
    pileCode: [{ required: true, message: '请输入IMEI号', trigger: 'blur' }],
    pileTypeNo: [{ required: true, message: '请选择充电桩型号名称', trigger: 'change' }],
    currentOutType: [{ required: true, message: '请选择电流输出类型', trigger: 'change' }],
    gunNum: [{ required: true, message: '请输入充电桩枪数', trigger: 'blur' }],
    //dealName: [{ required: true, message: '请选择经销商名称', trigger: 'change' }],
    optType: [{ required: true, message: '请选择充电桩类型', trigger: 'change' }],
    chargingSpeed: [{ required: true, message: '请选择充电速度', trigger: 'change' }],
    interfaceType: [{ required: true, message: '请选择接口标准', trigger: 'change' }],
    applyReason: [{ required: true, message: '请填写申请原因', trigger: 'blur' }],
    repairPerson: [{ required: true, message: '请填写维修人', trigger: 'blur' }],
    repairStatus: [{ required: true, message: '请选择维修状态', trigger: 'change' }],
    repairResult: [{ required: true, message: '请选择维修结果', trigger: 'change' }],
    repairDateNum: [{ required: true, message: '请填写维修时间', trigger: 'blur' }],
    corpReturn: [{ required: true, message: '请填写运营商回执', trigger: 'blur' }],
};

export default pageConfig;
